import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface ReturnRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  order: any;
  onSubmit: (returnData: any) => void;
}
const REASONS = ['Wrong item received', 'Item damaged or defective', 'No longer needed', 'Quality not as expected', 'Other'];
export function ReturnRequestModal({
  isOpen,
  onClose,
  order,
  onSubmit
}: ReturnRequestModalProps) {
  const [reason, setReason] = useState(REASONS[0]);
  const [details, setDetails] = useState('');
  if (!isOpen || !order) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      orderId: order.id,
      reason,
      details
    });
    setReason(REASONS[0]);
    setDetails('');
    onClose();
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" data-id="element-843" data-mp="2dmrst3ysic3x">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-xl overflow-hidden" data-id="element-844" data-mp="2iermwfs6iasl">
        <div className="flex items-center justify-between p-5 border-b border-gray-200" data-id="element-845" data-mp="24y7n1q6ndmq6">
          <div data-id="element-846" data-mp="20wugfdvqdfi7">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-847" data-mp="20x4abcjwc6t6">Return Request</h2>
            <p className="text-sm text-gray-600" data-id="element-848" data-mp="2enhing0p9nj1">{order.id}</p>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100" aria-label="Close" data-id="element-849" data-mp="29wr7fm5leqgf">
            <XIcon className="w-5 h-5" data-id="element-850" data-mp="2ojkfq7gp2vz4" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 space-y-4" data-id="element-851" data-mp="2jl972024yrih">
          <div data-id="element-852" data-mp="2xltpgv452lbg">
            <label className="text-sm font-medium text-gray-700" data-id="element-853" data-mp="2xmlj40e6e8z3">Reason</label>
            <select value={reason} onChange={e => setReason(e.target.value)} className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55]" data-id="element-854" data-mp="2smz5vqycksqa">
              {REASONS.map(r => <option key={r} value={r} data-id="element-855" data-mp="2yb7byfavli2a">
                  {r}
                </option>)}
            </select>
          </div>
          <div data-id="element-856" data-mp="33bd92azwzwrr">
            <label className="text-sm font-medium text-gray-700" data-id="element-857" data-mp="33atwzawy42ln">
              Additional Details
            </label>
            <textarea value={details} onChange={e => setDetails(e.target.value)} rows={4} placeholder="Provide more information about your return request..." className="mt-1 w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] resize-none" data-id="element-858" data-mp="38bhp5zwwuphg" />
          </div>
          <div className="flex gap-3 pt-2" data-id="element-859" data-mp="3r1zervmg54yl">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50" data-id="element-860" data-mp="3vzhcepv0jxra">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-4 py-2.5 bg-[#1E2B55] text-white font-medium rounded-lg hover:bg-[#162041]" data-id="element-861" data-mp="8s70sv2zkxvx">
              Submit Request
            </button>
          </div>
        </form>
      </div>
    </div>;
}